import { format, formatDistance } from 'date-fns';

export const DATE_FORMATS = {
  FULL: 'MMMM do, yyyy', // e.g., "January 1st, 2024"
  SHORT: 'MM-dd-yyyy', // e.g., "01-01-2024"
  TIME: 'h:mm a', // e.g., "3:30 PM"
  DATE_TIME: 'MMM d, h:mm a', // e.g., "Jan 5, 3:30 PM"
  DATE_SHORT_MONTH: 'MMM d', // e.g., "Jan 5"
  MONTH_YEAR: 'MMM yyyy', // e.g., "Jan 2024"
  YEAR: 'yyyy', // e.g., "2024"
  MONTH_ABBR: 'MMM', // e.g., "Jan"
  MEDIUM: 'MMM d, yyyy', // e.g., "Jan 5, 2024"
  WEEKDAY_SHORT: 'EEE MMM d', // e.g., "Fri Jun 5"
  DATE_KEY: 'yyyy-MM-dd' // e.g., "2024-01-05", the local day as an API date
};

export const formatDate = (date, formatType = DATE_FORMATS.FULL) => {
  return format(new Date(date), formatType);
};

export const formatDateDistance = (date) => {
  return formatDistance(new Date(date), new Date(), { addSuffix: true });
};

// Compact relative time for dense UI (e.g. recently-accessed cards): "Just now",
// "5m ago", "2h ago", "Yesterday", "3d ago", "2w ago", then falls back to a date.
export const formatRelativeShort = (date) => {
  const diffMinutes = Math.floor((new Date() - new Date(date)) / 60000);

  if (diffMinutes < 1) return 'Just now';
  if (diffMinutes < 60) return `${diffMinutes}m ago`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h ago`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 28) return `${Math.floor(diffDays / 7)}w ago`;

  return formatDate(date, DATE_FORMATS.SHORT);
};
